import VerifyInvitationPage from "~/pages/VerifyInvitationPage";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_public/verify-user-dataset")({
  component: VerifyInvitationPage,
  validateSearch(search) {
    return z.object({ token: z.string() }).parse(search);
  },
});
